// extracted by mini-css-extract-plugin
module.exports = {"side-nav-switch":"new-header-switch_side-nav-switch__CxJdS","arrow":"new-header-switch_arrow__21Sjl"};